<template>
  <v-data-table
    hide-default-footer
    :options="options"
    :items="data?.content ?? []"
    :server-items-length="data?.totalElements ?? 0"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-for="(_, slot) of $scopedSlots" #[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>

    <template #footer="{ props: footerProps }">
      <sds-data-table-footer :props="footerProps" @page:change="setPageable" />
    </template>
  </v-data-table>
</template>

<script setup lang="ts">
import { PaginatedRest } from '@/types/Rest';
import { DataOptions } from 'vuetify';
import { useVModel } from '@vueuse/core';
import { computed } from 'vue';

const emit = defineEmits(['page:change']);

const props = defineProps<{ value: PaginatedRest<unknown> }>();

const data = useVModel(props, undefined, emit);

const options = computed(() => ({
  page: data.value.number + 1,
  itemsPerPage: data.value.size,
  totalElements: data.value.totalElements,
}));

const setPageable = (pageable: DataOptions) => {
  const { page, itemsPerPage } = pageable;

  data.value.number = page - 1;
  data.value.size = itemsPerPage;

  emit('page:change');
};
</script>
